import { FC } from 'react'
import { TextArea } from '@cargomart/ui'

type Props = {
  error: string | undefined
  onBlur: any
  onChange: any
  onFocus: any
  value: string
}

export const OrderCreateComment: FC<Props> = ({ onChange, error, value, onBlur, onFocus }) => (
  <>
    <div className="text-sm pb-1 pt-2 font-normal text-on-surface-variant">Комментарий к заявке</div>
    <TextArea
      className="w-full"
      invalid={Boolean(error)}
      maxRows={8}
      minRows={1}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      value={value}
    />
    <div className="pb-2 text-body-sm font-normal text-on-surface-variant">Необязательно</div>
    {error && <span className="pb-2 pt-1 text-body-sm font-normal text-negative">{error}</span>}
  </>
)
